var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"title":"Overview"}},[_c('p',[_vm._v("Following is a brief look at how it works:")]),_c('vx-list',{staticClass:"mt-5",attrs:{"list":_vm.list}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }